import { Module, VuexModule, Mutation } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'user' })
export default class ModuleUser extends VuexModule {

    sessionDetail = {
        sessionId: '',
        userId: '',
        email: '',
        loginRefresh: '',
        loginExpired: '',
        channel: ''
    }

    userDetail = {
        userId: '',
        email: '',
        firstName: '',
        lastName: '',
        organization: '',
        position: '',
        phone: '',
        mobile: '',
        updateRequired: false
    }

    // Add agreement data to store
    agreementDetail = {
        agre_proce: '',
        agreementAccepted: false,
        lastUpdated: null as string | null
    }

    customerAccess = []

    customerDetail = {
        customerId: '',
        name: '',
        countryCode: '',
        status: '',
        update: '',
        code: '',
        latitude: 0,
        longitude: 0,
        longtitude: 0,
        emailSuffix: '',
        mapLayer: '',
        mapName: '',
        driveId: '',
        gmt: 0,
        maxNativeZoom: 19,
        maxZoom: 22
    }

    @Mutation
    storeSessionDetail(response: any) {
        assignResponse(response.sessionDetail, this.sessionDetail)
    }

    @Mutation
    storeUserDetail(response: any) {
        assignResponse(response.userDetail, this.userDetail)
    }

    @Mutation
    storeCustomerAccess(response: any) {
        this.customerAccess = response.permissionDetail[0].customerAccess
    }

    @Mutation
    storeCustomerDetail(response: any) {
        assignResponse(response.permissionDetail[0].customerDetail, this.customerDetail)
    }

    @Mutation
    storeAgreementDetail(agreementData: any) {
        this.agreementDetail.agre_proce = agreementData.agre_proce || ''
        
        const isAccepted = agreementData.agre_proce && 
            agreementData.agre_proce !== null && 
            agreementData.agre_proce !== '' && 
            agreementData.agre_proce !== '0000-00-00 00:00:00'
        
        this.agreementDetail.agreementAccepted = isAccepted
        this.agreementDetail.lastUpdated = new Date().toISOString()
    }

    @Mutation
    updateAgreementStatus(accepted: boolean) {
        this.agreementDetail.agreementAccepted = accepted
        if (accepted) {
            this.agreementDetail.agre_proce = new Date().toISOString()
        }
        this.agreementDetail.lastUpdated = new Date().toISOString()
    }
}

function assignResponse(responseReference: any, stateReference: object) {
    
    return Object.assign(stateReference, ...Object.keys(responseReference).map(key => ({
        [key]: responseReference[key]
    })))
}